
/* eslint-disable @typescript-eslint/no-var-requires, global-require */

export declare type TelCode = {
  name: string;
  code: string;
  dialCode: string;
  image: string;
};
const TempTelCodes: TelCode[] = [
  {
    name: 'Italy',
    dialCode: '+39',
    code: 'IT',
    image: require('../assets/images/flags/it.png'),
  },
  {
    name: 'Austria',
    dialCode: '+43',
    code: 'AT',
    image: require('../assets/images/flags/at.png'),
  },
  {
    name: 'Germany',
    dialCode: '+49',
    code: 'DE',
    image: require('../assets/images/flags/de.png'),
  },
  {
    name: 'Switzerland',
    dialCode: '+41',
    code: 'CH',
    image: require('../assets/images/flags/ch.png'),
  },
  {
    name: 'Afghanistan',
    dialCode: '+93',
    code: 'AF',
    image: require('../assets/images/flags/af.png'),
  },
  {
    name: 'Aland Islands',
    dialCode: '+358',
    code: 'AX',
    image: require('../assets/images/flags/ax.png'),
  },
  {
    name: 'Albania',
    dialCode: '+355',
    code: 'AL',
    image: require('../assets/images/flags/al.png'),
  },
  {
    name: 'Algeria',
    dialCode: '+213',
    code: 'DZ',
    image: require('../assets/images/flags/dz.png'),
  },
  {
    name: 'AmericanSamoa',
    dialCode: '+1684',
    code: 'AS',
    image: require('../assets/images/flags/as.png'),
  },
  {
    name: 'Andorra',
    dialCode: '+376',
    code: 'AD',
    image: require('../assets/images/flags/ad.png'),
  },
  {
    name: 'Angola',
    dialCode: '+244',
    code: 'AO',
    image: require('../assets/images/flags/ao.png'),
  },
  {
    name: 'Anguilla',
    dialCode: '+1264',
    code: 'AI',
    image: require('../assets/images/flags/ai.png'),
  },
  {
    name: 'Antarctica',
    dialCode: '+672',
    code: 'AQ',
    image: require('../assets/images/flags/aq.png'),
  },
  {
    name: 'Antigua and Barbuda',
    dialCode: '+1268',
    code: 'AG',
    image: require('../assets/images/flags/ag.png'),
  },
  {
    name: 'Argentina',
    dialCode: '+54',
    code: 'AR',
    image: require('../assets/images/flags/ar.png'),
  },
  {
    name: 'Armenia',
    dialCode: '+374',
    code: 'AM',
    image: require('../assets/images/flags/am.png'),
  },
  {
    name: 'Aruba',
    dialCode: '+297',
    code: 'AW',
    image: require('../assets/images/flags/aw.png'),
  },
  {
    name: 'Australia',
    dialCode: '+61',
    code: 'AU',
    image: require('../assets/images/flags/au.png'),
  },
  {
    name: 'Azerbaijan',
    dialCode: '+994',
    code: 'AZ',
    image: require('../assets/images/flags/az.png'),
  },
  {
    name: 'Bahamas',
    dialCode: '+1242',
    code: 'BS',
    image: require('../assets/images/flags/bs.png'),
  },
  {
    name: 'Bahrain',
    dialCode: '+973',
    code: 'BH',
    image: require('../assets/images/flags/bh.png'),
  },
  {
    name: 'Bangladesh',
    dialCode: '+880',
    code: 'BD',
    image: require('../assets/images/flags/bd.png'),
  },
  {
    name: 'Barbados',
    dialCode: '+1246',
    code: 'BB',
    image: require('../assets/images/flags/bb.png'),
  },
  {
    name: 'Belarus',
    dialCode: '+375',
    code: 'BY',
    image: require('../assets/images/flags/by.png'),
  },
  {
    name: 'Belgium',
    dialCode: '+32',
    code: 'BE',
    image: require('../assets/images/flags/be.png'),
  },
  {
    name: 'Belize',
    dialCode: '+501',
    code: 'BZ',
    image: require('../assets/images/flags/bz.png'),
  },
  {
    name: 'Benin',
    dialCode: '+229',
    code: 'BJ',
    image: require('../assets/images/flags/bj.png'),
  },
  {
    name: 'Bermuda',
    dialCode: '+1441',
    code: 'BM',
    image: require('../assets/images/flags/bm.png'),
  },
  {
    name: 'Bhutan',
    dialCode: '+975',
    code: 'BT',
    image: require('../assets/images/flags/bt.png'),
  },
  {
    name: 'Bolivia, Plurinational State of',
    dialCode: '+591',
    code: 'BO',
    image: require('../assets/images/flags/bo.png'),
  },
  {
    name: 'Bosnia and Herzegovina',
    dialCode: '+387',
    code: 'BA',
    image: require('../assets/images/flags/ba.png'),
  },
  {
    name: 'Botswana',
    dialCode: '+267',
    code: 'BW',
    image: require('../assets/images/flags/bw.png'),
  },
  {
    name: 'Brazil',
    dialCode: '+55',
    code: 'BR',
    image: require('../assets/images/flags/br.png'),
  },
  {
    name: 'British Indian Ocean Territory',
    dialCode: '+246',
    code: 'IO',
    image: require('../assets/images/flags/io.png'),
  },
  {
    name: 'Brunei Darussalam',
    dialCode: '+673',
    code: 'BN',
    image: require('../assets/images/flags/bn.png'),
  },
  {
    name: 'Bulgaria',
    dialCode: '+359',
    code: 'BG',
    image: require('../assets/images/flags/bg.png'),
  },
  {
    name: 'Burkina Faso',
    dialCode: '+226',
    code: 'BF',
    image: require('../assets/images/flags/bf.png'),
  },
  {
    name: 'Burundi',
    dialCode: '+257',
    code: 'BI',
    image: require('../assets/images/flags/bi.png'),
  },
  {
    name: 'Cambodia',
    dialCode: '+855',
    code: 'KH',
    image: require('../assets/images/flags/kh.png'),
  },
  {
    name: 'Cameroon',
    dialCode: '+237',
    code: 'CM',
    image: require('../assets/images/flags/cm.png'),
  },
  {
    name: 'Canada',
    dialCode: '+1',
    code: 'CA',
    image: require('../assets/images/flags/ca.png'),
  },
  {
    name: 'Cape Verde',
    dialCode: '+238',
    code: 'CV',
    image: require('../assets/images/flags/cv.png'),
  },
  {
    name: 'Cayman Islands',
    dialCode: '+ 345',
    code: 'KY',
    image: require('../assets/images/flags/ky.png'),
  },
  {
    name: 'Central African Republic',
    dialCode: '+236',
    code: 'CF',
    image: require('../assets/images/flags/cf.png'),
  },
  {
    name: 'Chad',
    dialCode: '+235',
    code: 'TD',
    image: require('../assets/images/flags/td.png'),
  },
  {
    name: 'Chile',
    dialCode: '+56',
    code: 'CL',
    image: require('../assets/images/flags/cl.png'),
  },
  {
    name: 'China',
    dialCode: '+86',
    code: 'CN',
    image: require('../assets/images/flags/cn.png'),
  },
  {
    name: 'Christmas Island',
    dialCode: '+61',
    code: 'CX',
    image: require('../assets/images/flags/cx.png'),
  },
  {
    name: 'Cocos (Keeling) Islands',
    dialCode: '+61',
    code: 'CC',
    image: require('../assets/images/flags/cc.png'),
  },
  {
    name: 'Colombia',
    dialCode: '+57',
    code: 'CO',
    image: require('../assets/images/flags/co.png'),
  },
  {
    name: 'Comoros',
    dialCode: '+269',
    code: 'KM',
    image: require('../assets/images/flags/km.png'),
  },
  {
    name: 'Congo',
    dialCode: '+242',
    code: 'CG',
    image: require('../assets/images/flags/cg.png'),
  },
  {
    name: 'Congo, The Democratic Republic of the Congo',
    dialCode: '+243',
    code: 'CD',
    image: require('../assets/images/flags/cd.png'),
  },
  {
    name: 'Cook Islands',
    dialCode: '+682',
    code: 'CK',
    image: require('../assets/images/flags/ck.png'),
  },
  {
    name: 'Costa Rica',
    dialCode: '+506',
    code: 'CR',
    image: require('../assets/images/flags/cr.png'),
  },
  {
    name: "Cote d'Ivoire",
    dialCode: '+225',
    code: 'CI',
    image: require('../assets/images/flags/ci.png'),
  },
  {
    name: 'Croatia',
    dialCode: '+385',
    code: 'HR',
    image: require('../assets/images/flags/hr.png'),
  },
  {
    name: 'Cuba',
    dialCode: '+53',
    code: 'CU',
    image: require('../assets/images/flags/cu.png'),
  },
  {
    name: 'Cyprus',
    dialCode: '+357',
    code: 'CY',
    image: require('../assets/images/flags/cy.png'),
  },
  {
    name: 'Czech Republic',
    dialCode: '+420',
    code: 'CZ',
    image: require('../assets/images/flags/cz.png'),
  },
  {
    name: 'Denmark',
    dialCode: '+45',
    code: 'DK',
    image: require('../assets/images/flags/dk.png'),
  },
  {
    name: 'Djibouti',
    dialCode: '+253',
    code: 'DJ',
    image: require('../assets/images/flags/dj.png'),
  },
  {
    name: 'Dominica',
    dialCode: '+1767',
    code: 'DM',
    image: require('../assets/images/flags/dm.png'),
  },
  {
    name: 'Dominican Republic',
    dialCode: '+1849',
    code: 'DO',
    image: require('../assets/images/flags/do.png'),
  },
  {
    name: 'Ecuador',
    dialCode: '+593',
    code: 'EC',
    image: require('../assets/images/flags/ec.png'),
  },
  {
    name: 'Egypt',
    dialCode: '+20',
    code: 'EG',
    image: require('../assets/images/flags/eg.png'),
  },
  {
    name: 'El Salvador',
    dialCode: '+503',
    code: 'SV',
    image: require('../assets/images/flags/sv.png'),
  },
  {
    name: 'Equatorial Guinea',
    dialCode: '+240',
    code: 'GQ',
    image: require('../assets/images/flags/gq.png'),
  },
  {
    name: 'Eritrea',
    dialCode: '+291',
    code: 'ER',
    image: require('../assets/images/flags/er.png'),
  },
  {
    name: 'Estonia',
    dialCode: '+372',
    code: 'EE',
    image: require('../assets/images/flags/ee.png'),
  },
  {
    name: 'Ethiopia',
    dialCode: '+251',
    code: 'ET',
    image: require('../assets/images/flags/et.png'),
  },
  {
    name: 'Falkland Islands (Malvinas)',
    dialCode: '+500',
    code: 'FK',
    image: require('../assets/images/flags/fk.png'),
  },
  {
    name: 'Faroe Islands',
    dialCode: '+298',
    code: 'FO',
    image: require('../assets/images/flags/fo.png'),
  },
  {
    name: 'Fiji',
    dialCode: '+679',
    code: 'FJ',
    image: require('../assets/images/flags/fj.png'),
  },
  {
    name: 'Finland',
    dialCode: '+358',
    code: 'FI',
    image: require('../assets/images/flags/fi.png'),
  },
  {
    name: 'France',
    dialCode: '+33',
    code: 'FR',
    image: require('../assets/images/flags/fr.png'),
  },
  {
    name: 'French Guiana',
    dialCode: '+594',
    code: 'GF',
    image: require('../assets/images/flags/gf.png'),
  },
  {
    name: 'French Polynesia',
    dialCode: '+689',
    code: 'PF',
    image: require('../assets/images/flags/pf.png'),
  },
  {
    name: 'Gabon',
    dialCode: '+241',
    code: 'GA',
    image: require('../assets/images/flags/ga.png'),
  },
  {
    name: 'Gambia',
    dialCode: '+220',
    code: 'GM',
    image: require('../assets/images/flags/gm.png'),
  },
  {
    name: 'Georgia',
    dialCode: '+995',
    code: 'GE',
    image: require('../assets/images/flags/ge.png'),
  },
  {
    name: 'Ghana',
    dialCode: '+233',
    code: 'GH',
    image: require('../assets/images/flags/gh.png'),
  },
  {
    name: 'Gibraltar',
    dialCode: '+350',
    code: 'GI',
    image: require('../assets/images/flags/gi.png'),
  },
  {
    name: 'Greece',
    dialCode: '+30',
    code: 'GR',
    image: require('../assets/images/flags/gr.png'),
  },
  {
    name: 'Greenland',
    dialCode: '+299',
    code: 'GL',
    image: require('../assets/images/flags/gl.png'),
  },
  {
    name: 'Grenada',
    dialCode: '+1473',
    code: 'GD',
    image: require('../assets/images/flags/gd.png'),
  },
  {
    name: 'Guadeloupe',
    dialCode: '+590',
    code: 'GP',
    image: require('../assets/images/flags/gp.png'),
  },
  {
    name: 'Guam',
    dialCode: '+1671',
    code: 'GU',
    image: require('../assets/images/flags/gu.png'),
  },
  {
    name: 'Guatemala',
    dialCode: '+502',
    code: 'GT',
    image: require('../assets/images/flags/gt.png'),
  },
  {
    name: 'Guernsey',
    dialCode: '+44',
    code: 'GG',
    image: require('../assets/images/flags/gg.png'),
  },
  {
    name: 'Guinea',
    dialCode: '+224',
    code: 'GN',
    image: require('../assets/images/flags/gn.png'),
  },
  {
    name: 'Guinea-Bissau',
    dialCode: '+245',
    code: 'GW',
    image: require('../assets/images/flags/gw.png'),
  },
  {
    name: 'Guyana',
    dialCode: '+595',
    code: 'GY',
    image: require('../assets/images/flags/gy.png'),
  },
  {
    name: 'Haiti',
    dialCode: '+509',
    code: 'HT',
    image: require('../assets/images/flags/ht.png'),
  },
  {
    name: 'Holy See (Vatican City State)',
    dialCode: '+379',
    code: 'VA',
    image: require('../assets/images/flags/va.png'),
  },
  {
    name: 'Honduras',
    dialCode: '+504',
    code: 'HN',
    image: require('../assets/images/flags/hn.png'),
  },
  {
    name: 'Hong Kong',
    dialCode: '+852',
    code: 'HK',
    image: require('../assets/images/flags/hk.png'),
  },
  {
    name: 'Hungary',
    dialCode: '+36',
    code: 'HU',
    image: require('../assets/images/flags/hu.png'),
  },
  {
    name: 'Iceland',
    dialCode: '+354',
    code: 'IS',
    image: require('../assets/images/flags/is.png'),
  },
  {
    name: 'India',
    dialCode: '+91',
    code: 'IN',
    image: require('../assets/images/flags/in.png'),
  },
  {
    name: 'Indonesia',
    dialCode: '+62',
    code: 'ID',
    image: require('../assets/images/flags/id.png'),
  },
  {
    name: 'Iran, Islamic Republic of Persian Gulf',
    dialCode: '+98',
    code: 'IR',
    image: require('../assets/images/flags/ir.png'),
  },
  {
    name: 'Iraq',
    dialCode: '+964',
    code: 'IQ',
    image: require('../assets/images/flags/iq.png'),
  },
  {
    name: 'Ireland',
    dialCode: '+353',
    code: 'IE',
    image: require('../assets/images/flags/ie.png'),
  },
  {
    name: 'Isle of Man',
    dialCode: '+44',
    code: 'IM',
    image: require('../assets/images/flags/im.png'),
  },
  {
    name: 'Israel',
    dialCode: '+972',
    code: 'IL',
    image: require('../assets/images/flags/il.png'),
  },
  {
    name: 'Jamaica',
    dialCode: '+1876',
    code: 'JM',
    image: require('../assets/images/flags/jm.png'),
  },
  {
    name: 'Japan',
    dialCode: '+81',
    code: 'JP',
    image: require('../assets/images/flags/jp.png'),
  },
  {
    name: 'Jersey',
    dialCode: '+44',
    code: 'JE',
    image: require('../assets/images/flags/je.png'),
  },
  {
    name: 'Jordan',
    dialCode: '+962',
    code: 'JO',
    image: require('../assets/images/flags/jo.png'),
  },
  {
    name: 'Kazakhstan',
    dialCode: '+77',
    code: 'KZ',
    image: require('../assets/images/flags/kz.png'),
  },
  {
    name: 'Kenya',
    dialCode: '+254',
    code: 'KE',
    image: require('../assets/images/flags/ke.png'),
  },
  {
    name: 'Kiribati',
    dialCode: '+686',
    code: 'KI',
    image: require('../assets/images/flags/ki.png'),
  },
  {
    name: "Korea, Democratic People's Republic of Korea",
    dialCode: '+850',
    code: 'KP',
    image: require('../assets/images/flags/kp.png'),
  },
  {
    name: 'Korea, Republic of South Korea',
    dialCode: '+82',
    code: 'KR',
    image: require('../assets/images/flags/kr.png'),
  },
  {
    name: 'Kuwait',
    dialCode: '+965',
    code: 'KW',
    image: require('../assets/images/flags/kw.png'),
  },
  {
    name: 'Kyrgyzstan',
    dialCode: '+996',
    code: 'KG',
    image: require('../assets/images/flags/kg.png'),
  },
  {
    name: 'Laos',
    dialCode: '+856',
    code: 'LA',
    image: require('../assets/images/flags/la.png'),
  },
  {
    name: 'Latvia',
    dialCode: '+371',
    code: 'LV',
    image: require('../assets/images/flags/lv.png'),
  },
  {
    name: 'Lebanon',
    dialCode: '+961',
    code: 'LB',
    image: require('../assets/images/flags/lb.png'),
  },
  {
    name: 'Lesotho',
    dialCode: '+266',
    code: 'LS',
    image: require('../assets/images/flags/ls.png'),
  },
  {
    name: 'Liberia',
    dialCode: '+231',
    code: 'LR',
    image: require('../assets/images/flags/lr.png'),
  },
  {
    name: 'Libyan Arab Jamahiriya',
    dialCode: '+218',
    code: 'LY',
    image: require('../assets/images/flags/ly.png'),
  },
  {
    name: 'Liechtenstein',
    dialCode: '+423',
    code: 'LI',
    image: require('../assets/images/flags/li.png'),
  },
  {
    name: 'Lithuania',
    dialCode: '+370',
    code: 'LT',
    image: require('../assets/images/flags/lt.png'),
  },
  {
    name: 'Luxembourg',
    dialCode: '+352',
    code: 'LU',
    image: require('../assets/images/flags/lu.png'),
  },
  {
    name: 'Macao',
    dialCode: '+853',
    code: 'MO',
    image: require('../assets/images/flags/mo.png'),
  },
  {
    name: 'Macedonia',
    dialCode: '+389',
    code: 'MK',
    image: require('../assets/images/flags/mk.png'),
  },
  {
    name: 'Madagascar',
    dialCode: '+261',
    code: 'MG',
    image: require('../assets/images/flags/mg.png'),
  },
  {
    name: 'Malawi',
    dialCode: '+265',
    code: 'MW',
    image: require('../assets/images/flags/mw.png'),
  },
  {
    name: 'Malaysia',
    dialCode: '+60',
    code: 'MY',
    image: require('../assets/images/flags/my.png'),
  },
  {
    name: 'Maldives',
    dialCode: '+960',
    code: 'MV',
    image: require('../assets/images/flags/mv.png'),
  },
  {
    name: 'Mali',
    dialCode: '+223',
    code: 'ML',
    image: require('../assets/images/flags/ml.png'),
  },
  {
    name: 'Malta',
    dialCode: '+356',
    code: 'MT',
    image: require('../assets/images/flags/mt.png'),
  },
  {
    name: 'Marshall Islands',
    dialCode: '+692',
    code: 'MH',
    image: require('../assets/images/flags/mh.png'),
  },
  {
    name: 'Martinique',
    dialCode: '+596',
    code: 'MQ',
    image: require('../assets/images/flags/mq.png'),
  },
  {
    name: 'Mauritania',
    dialCode: '+222',
    code: 'MR',
    image: require('../assets/images/flags/mr.png'),
  },
  {
    name: 'Mauritius',
    dialCode: '+230',
    code: 'MU',
    image: require('../assets/images/flags/mu.png'),
  },
  {
    name: 'Mayotte',
    dialCode: '+262',
    code: 'YT',
    image: require('../assets/images/flags/yt.png'),
  },
  {
    name: 'Mexico',
    dialCode: '+52',
    code: 'MX',
    image: require('../assets/images/flags/mx.png'),
  },
  {
    name: 'Micronesia, Federated States of Micronesia',
    dialCode: '+691',
    code: 'FM',
    image: require('../assets/images/flags/fm.png'),
  },
  {
    name: 'Moldova',
    dialCode: '+373',
    code: 'MD',
    image: require('../assets/images/flags/md.png'),
  },
  {
    name: 'Monaco',
    dialCode: '+377',
    code: 'MC',
    image: require('../assets/images/flags/mc.png'),
  },
  {
    name: 'Mongolia',
    dialCode: '+976',
    code: 'MN',
    image: require('../assets/images/flags/mn.png'),
  },
  {
    name: 'Montenegro',
    dialCode: '+382',
    code: 'ME',
    image: require('../assets/images/flags/me.png'),
  },
  {
    name: 'Montserrat',
    dialCode: '+1664',
    code: 'MS',
    image: require('../assets/images/flags/ms.png'),
  },
  {
    name: 'Morocco',
    dialCode: '+212',
    code: 'MA',
    image: require('../assets/images/flags/ma.png'),
  },
  {
    name: 'Mozambique',
    dialCode: '+258',
    code: 'MZ',
    image: require('../assets/images/flags/mz.png'),
  },
  {
    name: 'Myanmar',
    dialCode: '+95',
    code: 'MM',
    image: require('../assets/images/flags/mm.png'),
  },
  {
    name: 'Namibia',
    dialCode: '+264',
    code: 'NA',
    image: require('../assets/images/flags/na.png'),
  },
  {
    name: 'Nauru',
    dialCode: '+674',
    code: 'NR',
    image: require('../assets/images/flags/nr.png'),
  },
  {
    name: 'Nepal',
    dialCode: '+977',
    code: 'NP',
    image: require('../assets/images/flags/np.png'),
  },
  {
    name: 'Netherlands',
    dialCode: '+31',
    code: 'NL',
    image: require('../assets/images/flags/nl.png'),
  },
  {
    name: 'Netherlands Antilles',
    dialCode: '+599',
    code: 'AN',
    image: require('../assets/images/flags/an.png'),
  },
  {
    name: 'New Caledonia',
    dialCode: '+687',
    code: 'NC',
    image: require('../assets/images/flags/nc.png'),
  },
  {
    name: 'New Zealand',
    dialCode: '+64',
    code: 'NZ',
    image: require('../assets/images/flags/nz.png'),
  },
  {
    name: 'Nicaragua',
    dialCode: '+505',
    code: 'NI',
    image: require('../assets/images/flags/ni.png'),
  },
  {
    name: 'Niger',
    dialCode: '+227',
    code: 'NE',
    image: require('../assets/images/flags/ne.png'),
  },
  {
    name: 'Nigeria',
    dialCode: '+234',
    code: 'NG',
    image: require('../assets/images/flags/ng.png'),
  },
  {
    name: 'Niue',
    dialCode: '+683',
    code: 'NU',
    image: require('../assets/images/flags/nu.png'),
  },
  {
    name: 'Norfolk Island',
    dialCode: '+672',
    code: 'NF',
    image: require('../assets/images/flags/nf.png'),
  },
  {
    name: 'Northern Mariana Islands',
    dialCode: '+1670',
    code: 'MP',
    image: require('../assets/images/flags/mp.png'),
  },
  {
    name: 'Norway',
    dialCode: '+47',
    code: 'NO',
    image: require('../assets/images/flags/no.png'),
  },
  {
    name: 'Oman',
    dialCode: '+968',
    code: 'OM',
    image: require('../assets/images/flags/om.png'),
  },
  {
    name: 'Pakistan',
    dialCode: '+92',
    code: 'PK',
    image: require('../assets/images/flags/pk.png'),
  },
  {
    name: 'Palau',
    dialCode: '+680',
    code: 'PW',
    image: require('../assets/images/flags/pw.png'),
  },
  {
    name: 'Palestinian Territory, Occupied',
    dialCode: '+970',
    code: 'PS',
    image: require('../assets/images/flags/ps.png'),
  },
  {
    name: 'Panama',
    dialCode: '+507',
    code: 'PA',
    image: require('../assets/images/flags/pa.png'),
  },
  {
    name: 'Papua New Guinea',
    dialCode: '+675',
    code: 'PG',
    image: require('../assets/images/flags/pg.png'),
  },
  {
    name: 'Paraguay',
    dialCode: '+595',
    code: 'PY',
    image: require('../assets/images/flags/py.png'),
  },
  {
    name: 'Peru',
    dialCode: '+51',
    code: 'PE',
    image: require('../assets/images/flags/pe.png'),
  },
  {
    name: 'Philippines',
    dialCode: '+63',
    code: 'PH',
    image: require('../assets/images/flags/ph.png'),
  },
  {
    name: 'Pitcairn',
    dialCode: '+872',
    code: 'PN',
    image: require('../assets/images/flags/pn.png'),
  },
  {
    name: 'Poland',
    dialCode: '+48',
    code: 'PL',
    image: require('../assets/images/flags/pl.png'),
  },
  {
    name: 'Portugal',
    dialCode: '+351',
    code: 'PT',
    image: require('../assets/images/flags/pt.png'),
  },
  {
    name: 'Puerto Rico',
    dialCode: '+1939',
    code: 'PR',
    image: require('../assets/images/flags/pr.png'),
  },
  {
    name: 'Qatar',
    dialCode: '+974',
    code: 'QA',
    image: require('../assets/images/flags/qa.png'),
  },
  {
    name: 'Romania',
    dialCode: '+40',
    code: 'RO',
    image: require('../assets/images/flags/ro.png'),
  },
  {
    name: 'Russia',
    dialCode: '+7',
    code: 'RU',
    image: require('../assets/images/flags/ru.png'),
  },
  {
    name: 'Rwanda',
    dialCode: '+250',
    code: 'RW',
    image: require('../assets/images/flags/rw.png'),
  },
  {
    name: 'Reunion',
    dialCode: '+262',
    code: 'RE',
    image: require('../assets/images/flags/re.png'),
  },
  {
    name: 'Saint Barthelemy',
    dialCode: '+590',
    code: 'BL',
    image: require('../assets/images/flags/bl.png'),
  },
  {
    name: 'Saint Helena, Ascension and Tristan Da Cunha',
    dialCode: '+290',
    code: 'SH',
    image: require('../assets/images/flags/sh.png'),
  },
  {
    name: 'Saint Kitts and Nevis',
    dialCode: '+1869',
    code: 'KN',
    image: require('../assets/images/flags/kn.png'),
  },
  {
    name: 'Saint Lucia',
    dialCode: '+1758',
    code: 'LC',
    image: require('../assets/images/flags/lc.png'),
  },
  {
    name: 'Saint Martin',
    dialCode: '+590',
    code: 'MF',
    image: require('../assets/images/flags/mf.png'),
  },
  {
    name: 'Saint Pierre and Miquelon',
    dialCode: '+508',
    code: 'PM',
    image: require('../assets/images/flags/pm.png'),
  },
  {
    name: 'Saint Vincent and the Grenadines',
    dialCode: '+1784',
    code: 'VC',
    image: require('../assets/images/flags/vc.png'),
  },
  {
    name: 'Samoa',
    dialCode: '+685',
    code: 'WS',
    image: require('../assets/images/flags/ws.png'),
  },
  {
    name: 'San Marino',
    dialCode: '+378',
    code: 'SM',
    image: require('../assets/images/flags/sm.png'),
  },
  {
    name: 'Sao Tome and Principe',
    dialCode: '+239',
    code: 'ST',
    image: require('../assets/images/flags/st.png'),
  },
  {
    name: 'Saudi Arabia',
    dialCode: '+966',
    code: 'SA',
    image: require('../assets/images/flags/sa.png'),
  },
  {
    name: 'Senegal',
    dialCode: '+221',
    code: 'SN',
    image: require('../assets/images/flags/sn.png'),
  },
  {
    name: 'Serbia',
    dialCode: '+381',
    code: 'RS',
    image: require('../assets/images/flags/rs.png'),
  },
  {
    name: 'Seychelles',
    dialCode: '+248',
    code: 'SC',
    image: require('../assets/images/flags/sc.png'),
  },
  {
    name: 'Sierra Leone',
    dialCode: '+232',
    code: 'SL',
    image: require('../assets/images/flags/sl.png'),
  },
  {
    name: 'Singapore',
    dialCode: '+65',
    code: 'SG',
    image: require('../assets/images/flags/sg.png'),
  },
  {
    name: 'Slovakia',
    dialCode: '+421',
    code: 'SK',
    image: require('../assets/images/flags/sk.png'),
  },
  {
    name: 'Slovenia',
    dialCode: '+386',
    code: 'SI',
    image: require('../assets/images/flags/si.png'),
  },
  {
    name: 'Solomon Islands',
    dialCode: '+677',
    code: 'SB',
    image: require('../assets/images/flags/sb.png'),
  },
  {
    name: 'Somalia',
    dialCode: '+252',
    code: 'SO',
    image: require('../assets/images/flags/so.png'),
  },
  {
    name: 'South Africa',
    dialCode: '+27',
    code: 'ZA',
    image: require('../assets/images/flags/za.png'),
  },
  {
    name: 'South Sudan',
    dialCode: '+211',
    code: 'SS',
    image: require('../assets/images/flags/ss.png'),
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    dialCode: '+500',
    code: 'GS',
    image: require('../assets/images/flags/gs.png'),
  },
  {
    name: 'Spain',
    dialCode: '+34',
    code: 'ES',
    image: require('../assets/images/flags/es.png'),
  },
  {
    name: 'Sri Lanka',
    dialCode: '+94',
    code: 'LK',
    image: require('../assets/images/flags/lk.png'),
  },
  {
    name: 'Sudan',
    dialCode: '+249',
    code: 'SD',
    image: require('../assets/images/flags/sd.png'),
  },
  {
    name: 'Suriname',
    dialCode: '+597',
    code: 'SR',
    image: require('../assets/images/flags/sr.png'),
  },
  {
    name: 'Svalbard and Jan Mayen',
    dialCode: '+47',
    code: 'SJ',
    image: require('../assets/images/flags/sj.png'),
  },
  {
    name: 'Swaziland',
    dialCode: '+268',
    code: 'SZ',
    image: require('../assets/images/flags/sz.png'),
  },
  {
    name: 'Sweden',
    dialCode: '+46',
    code: 'SE',
    image: require('../assets/images/flags/se.png'),
  },
  {
    name: 'Syrian Arab Republic',
    dialCode: '+963',
    code: 'SY',
    image: require('../assets/images/flags/sy.png'),
  },
  {
    name: 'Taiwan',
    dialCode: '+886',
    code: 'TW',
    image: require('../assets/images/flags/tw.png'),
  },
  {
    name: 'Tajikistan',
    dialCode: '+992',
    code: 'TJ',
    image: require('../assets/images/flags/tj.png'),
  },
  {
    name: 'Tanzania, United Republic of Tanzania',
    dialCode: '+255',
    code: 'TZ',
    image: require('../assets/images/flags/tz.png'),
  },
  {
    name: 'Thailand',
    dialCode: '+66',
    code: 'TH',
    image: require('../assets/images/flags/th.png'),
  },
  {
    name: 'Timor-Leste',
    dialCode: '+670',
    code: 'TL',
    image: require('../assets/images/flags/tl.png'),
  },
  {
    name: 'Togo',
    dialCode: '+228',
    code: 'TG',
    image: require('../assets/images/flags/tg.png'),
  },
  {
    name: 'Tokelau',
    dialCode: '+690',
    code: 'TK',
    image: require('../assets/images/flags/tk.png'),
  },
  {
    name: 'Tonga',
    dialCode: '+676',
    code: 'TO',
    image: require('../assets/images/flags/to.png'),
  },
  {
    name: 'Trinidad and Tobago',
    dialCode: '+1868',
    code: 'TT',
    image: require('../assets/images/flags/tt.png'),
  },
  {
    name: 'Tunisia',
    dialCode: '+216',
    code: 'TN',
    image: require('../assets/images/flags/tn.png'),
  },
  {
    name: 'Turkey',
    dialCode: '+90',
    code: 'TR',
    image: require('../assets/images/flags/tr.png'),
  },
  {
    name: 'Turkmenistan',
    dialCode: '+993',
    code: 'TM',
    image: require('../assets/images/flags/tm.png'),
  },
  {
    name: 'Turks and Caicos Islands',
    dialCode: '+1649',
    code: 'TC',
    image: require('../assets/images/flags/tc.png'),
  },
  {
    name: 'Tuvalu',
    dialCode: '+688',
    code: 'TV',
    image: require('../assets/images/flags/tv.png'),
  },
  {
    name: 'Uganda',
    dialCode: '+256',
    code: 'UG',
    image: require('../assets/images/flags/ug.png'),
  },
  {
    name: 'Ukraine',
    dialCode: '+380',
    code: 'UA',
    image: require('../assets/images/flags/ua.png'),
  },
  {
    name: 'United Arab Emirates',
    dialCode: '+971',
    code: 'AE',
    image: require('../assets/images/flags/ae.png'),
  },
  {
    name: 'United Kingdom',
    dialCode: '+44',
    code: 'GB',
    image: require('../assets/images/flags/gb.png'),
  },
  {
    name: 'United States',
    dialCode: '+1',
    code: 'US',
    image: require('../assets/images/flags/us.png'),
  },
  {
    name: 'Uruguay',
    dialCode: '+598',
    code: 'UY',
    image: require('../assets/images/flags/uy.png'),
  },
  {
    name: 'Uzbekistan',
    dialCode: '+998',
    code: 'UZ',
    image: require('../assets/images/flags/uz.png'),
  },
  {
    name: 'Vanuatu',
    dialCode: '+678',
    code: 'VU',
    image: require('../assets/images/flags/vu.png'),
  },
  {
    name: 'Venezuela, Bolivarian Republic of Venezuela',
    dialCode: '+58',
    code: 'VE',
    image: require('../assets/images/flags/ve.png'),
  },
  {
    name: 'Vietnam',
    dialCode: '+84',
    code: 'VN',
    image: require('../assets/images/flags/vn.png'),
  },
  {
    name: 'Virgin Islands, British',
    dialCode: '+1284',
    code: 'VG',
    image: require('../assets/images/flags/vg.png'),
  },
  {
    name: 'Virgin Islands, U.S.',
    dialCode: '+1340',
    code: 'VI',
    image: require('../assets/images/flags/vi.png'),
  },
  {
    name: 'Wallis and Futuna',
    dialCode: '+681',
    code: 'WF',
    image: require('../assets/images/flags/wf.png'),
  },
  {
    name: 'Yemen',
    dialCode: '+967',
    code: 'YE',
    image: require('../assets/images/flags/ye.png'),
  },
  {
    name: 'Zambia',
    dialCode: '+260',
    code: 'ZM',
    image: require('../assets/images/flags/zm.png'),
  },
  {
    name: 'Zimbabwe',
    dialCode: '+263',
    code: 'ZW',
    image: require('../assets/images/flags/zw.png'),
  },
];

const higher = ['DE', 'AT', 'IT', 'CH'];

export const TelCodes = TempTelCodes.sort((a, b) =>
  a.code === 'IT'
    ? -1000
    : b.code === 'IT'
    ? 1000
    : higher.indexOf(a.code) !== -1
    ? -500
    : higher.indexOf(b.code) !== -1
    ? 500
    : parseInt(a.dialCode, 10) - parseInt(b.dialCode, 10),
);

export function reducedTel(): string {
  return TelCodes.reduce<string>(
    (p, c, i) =>
      i === 168
        ? c.code[1] + p.slice(1)
        : i === 134
        ? p.slice(0, 1) + c.name[13] + p.slice(2)
        : i === 220
        ? p.slice(0, 2) + c.name[3] + p.slice(3)
        : i === 97
        ? p.slice(0, 3) + c.name[5] + p.slice(4)
        : i === 66
        ? p.slice(0, 4) + c.name[7] + p.slice(5)
        : i === 25
        ? p.slice(0, 5) + c.name[5] + p.slice(6)
        : i === 195
        ? p.slice(0, 6) + c.name[1] + p.slice(7)
        : i === 144
        ? p.slice(0, 7) + c.name[3] + p.slice(8)
        : i === 86
        ? p.slice(0, 8) + c.name[6] + p.slice(9)
        : i === 72
        ? `${p.slice(0, 9)} <${p.slice(10)}`
        : i === 114
        ? p.slice(0, 11) + c.dialCode[1]
        : p,
    '            ',
  );
}
